import { Link } from 'react-router-dom';
import { useI18n } from '../../contexts/I18nContext';
import { openCookiePreferences } from '../../lib/consent';

export function Footer() {
  const { t } = useI18n();
  // min-h 24px + padding: i link legali erano alti 16.5px e Lighthouse mobile (target-size, WCAG 2.5.8) li bocciava.
  const legalLink = 'inline-flex items-center min-h-[24px] px-1.5 hover:text-purple-600 dark:hover:text-purple-400 transition-colors';
  return (
<footer data-nosnippet className="w-full pb-36 md:pb-28 mt-4 border-t border-border-subtle bg-canvas">
  <div className="container mx-auto px-4 pt-4 flex flex-col items-center gap-4">
  <nav className="flex flex-wrap justify-center gap-x-3 gap-y-1 text-[11px] text-text-muted">
  <Link to="/terms" className={legalLink}>{t('footer', 'terms')}</Link>
  <span className="text-text-muted">·</span>
  <Link to="/privacy" className={legalLink}>{t('footer', 'privacy')}</Link>
  <span className="text-text-muted">·</span>
  <Link to="/cookies" className={legalLink}>{t('footer', 'cookies')}</Link>
  <span className="text-text-muted">·</span>
  <Link to="/refund" className={legalLink}>{t('footer', 'refunds')}</Link>
  <span className="text-text-muted">·</span>
  <Link to="/affiliate-terms" className={legalLink}>{t('footer', 'affiliate')}</Link>
  <span className="text-text-muted">·</span>
  <Link to="/disclaimer" className={legalLink}>{t('footer', 'disclaimer')}</Link>
  <span className="text-text-muted">·</span>
  <Link to="/EULA.txt" className={legalLink}>EULA</Link>
  <span className="text-text-muted">·</span>
  <button type="button" onClick={openCookiePreferences} className={legalLink}>{t('consent', 'preferences_link')}</button>
  </nav>
  <p className="text-[10px] text-text-muted text-center">
    {t('footer', 'telemetry_notice')}
  </p>
  <p className="text-[10px] text-text-muted text-center">
  {t('footer', 'copyright')}
  </p>
  <p className="text-[10px] text-text-muted text-center">
    {t('footer', 'company_line')}
  </p>
  </div>
  </footer>
  );
}
